export default __webpack_public_path__ + "4f84f7d03b661d19aa1fe06a2d607ea1.jpg";